import { createFileRoute } from "@tanstack/react-router"
import type { Uuid } from "@/utils"
import WorkflowPage from "@/workflow/layout/WorkflowPage"

export const Route = createFileRoute("/(user)/t/$tenantSlug/workflows/$id")({
  component: RouteComponent,
  validateSearch: (search) =>
    search as {
      draft?: string
      revision?: string
      runId?: Uuid
      nodeRunId?: Uuid
      history?: true
    },
})

function RouteComponent() {
  const { id } = Route.useParams()
  const { draft, revision, runId, nodeRunId } = Route.useSearch()

  return (
    <WorkflowPage
      id={id}
      draftId={draft}
      revisionIdOrTag={revision}
      runId={runId}
      nodeRunId={nodeRunId}
    />
  )
}
